import { ToastContext } from '@/entities/toast/lib/context'
import { useContext } from 'react'

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastContextProvider')
  }
  return context
}
